export default __webpack_public_path__ + "static/media/HOLMAJ25.80d4a0ed.jpg";